import { render } from "./check-box.vue?vue&type=template&id=5fb9eb21&scoped=true&ts=true"
import script from "./check-box.vue?vue&type=script&lang=ts"
export * from "./check-box.vue?vue&type=script&lang=ts"

import "./check-box.vue?vue&type=style&index=0&id=5fb9eb21&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb9eb21"]])

export default __exports__